import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { Button, Card, CardBody } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { constants, UserContext, } from "../utils";
import { DoublingCalcs, TwistingCalcs } from ".";

export default function EngineerTools() {
   const { currentUser } = useContext(UserContext);
   const navigate = useNavigate();
   const [showDoubling, setShowDoubling] = useState(true);    // Doubler Calculations
   const [showTwisting, setShowTwisting] = useState(false);   // Twisting Calculations

   useEffect(() => {
      if (!currentUser) return;
      if (!currentUser.isAdmin && !currentUser.isPowerUser && !currentUser.isEngineerRole) {
         toast.error("Unauthorized");
         var nav = constants.ENDPOINTS.home;
         navigate(nav);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentUser])

   function ResetButtons(val) {
      if ((showDoubling && val !== "showDoubling")
         || (!showDoubling && val === "showDoubling"))
         setShowDoubling(!showDoubling);

      if ((showTwisting && val !== "showTwisting")
         || (!showTwisting && val === "showTwisting"))
         setShowTwisting(!showTwisting);
   }

   return (
      document.title = `Engineering Tools`,
      <DesktopContainer screenName="Engineering Tools">
         <div className="filter-header sticky-top">
            <div className="dashboard-button-container">
               <Button
                  children={"Doubling"}
                  className="filter-button"
                  onClick={() => ResetButtons("showDoubling")}
                  active={showDoubling}
               />
               <Button
                  children={"Twisting"}
                  className="filter-button"
                  onClick={() => ResetButtons("showTwisting")}
                  active={showTwisting}
               />
            </div>
         </div>

         {showDoubling ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Doubling & Winding Calculations</span></div>
                  <hr />
                  <DoublingCalcs />
               </CardBody>
            </Card>
         ) : (false)}

         {showTwisting ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Twisting Calculations</span></div>
                  <hr />
                  <TwistingCalcs />
               </CardBody>
            </Card>
         ) : (false)}

      </DesktopContainer >
   );
}
